// ═══════════════════════════════════════════════════════════════════════════════
// Restrict route to a single role (main app shell; user is already authenticated)
// ═══════════════════════════════════════════════════════════════════════════════

import { Navigate } from 'react-router-dom';
import type { UserRole } from '@fdh/shared';
import { USER_ROLE } from '@fdh/shared';
import { useAuth } from '../../contexts/AuthContext';

type RequireRoleProps = {
  role: UserRole;
  children: React.ReactNode;
};

export const RequireRole = ({ role, children }: RequireRoleProps) => {
  const { user } = useAuth();
  if (!user) {
    return null;
  }
  if (user.role !== role) {
    const fallback = user.role === USER_ROLE.EMPLOYER ? '/dashboard' : '/home';
    return <Navigate to={fallback} replace />;
  }
  return <>{children}</>;
};
